import { Box, Text } from '@chakra-ui/react';

export function StatusSelector() {
  return (
    <Box mb={{ base: '4', md: '0' }}>
      <Text
        as="p"
        mb="2"
        fontSize={{ base: 'sm', md: 'md' }}
        fontWeight="medium"
        color="volyx.text"
      >
        Schedule
      </Text>
    </Box>
  );
}
